"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.session = void 0;
var _uuid = require("uuid");
var _browser = require("../../utils/browser");
/* eslint-disable sort-keys */

/**
 * This is a singleton object containing splunk logger session data.
 * If there is no userId provided the logs will be emitted to a stream using an anonymous id.
 */
var session = {
  initialized: false,
  userId: null,
  setUserId: function setUserId(userId) {
    if (userId) {
      this.userId = userId;
      (0, _browser.getLocalStorage)().removeItem('anonymousId');
    }
  },
  setInitialized: function setInitialized() {
    this.initialized = true;
  },
  get logStreamName() {
    if (this.userId) {
      return this.userId;
    }

    // using local storage to avoid errors around multiple tab usage
    var anonymousId = (0, _browser.getLocalStorage)().getItem('anonymousId');
    if (!anonymousId) {
      var newAnonymousId = (0, _uuid.v4)();
      (0, _browser.getLocalStorage)().setItem('anonymousId', newAnonymousId);
      return "anonymous-".concat(newAnonymousId);
    }
    return "anonymous-".concat(anonymousId);
  },
  reset: function reset() {
    this.initialized = false;
    this.userId = null;
  }
};
exports.session = session;